var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DataListStateful',{attrs:{"title":"Типы упаковок","resource":"package-types","store":"packageTypes","columns":_vm.columns,"filter-options":_vm.filter,"disable-adding":_vm.isAdmin ? false : true}})
}
var staticRenderFns = []

export { render, staticRenderFns }